import React from 'react';
import BaseSelector, { Option } from '@components/selectors/BaseSelector';
import { storeSubcategory } from '@components/agile/types/AgileMacroplanogramTypes';

interface SubcategorySelectorProps {
  value?: string;
  onChange: (subcategoryId: string) => void;
  subcategories: storeSubcategory[];
  disabled?: boolean;
  label?: string;
}

/**
 * Subcategory selector dropdown.
 * Populated from the selected macroplanogram's storeSubcategories.
 * Selection is optional (acts as an additional filter).
 */
const SubcategorySelector: React.FC<SubcategorySelectorProps> = ({
  value,
  onChange,
  subcategories,
  disabled = false,
  label = 'Subcategory',
}) => {
  const options: Option[] = subcategories.map((sc) => ({
    value: sc.subcategoryId,
    label: sc.subcategoryName,
  }));

  return (
    <BaseSelector<Option>
      label={label}
      placeholder={disabled ? 'Select a macroplanogram first' : `All ${label}`}
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default SubcategorySelector;
